import React, { useEffect, useState, useRef } from 'react'
import { CreateWhatsappAPI, DeleteWhatsappAPI, getWhatsappApi, logEvent, resetWhatsAppGateway, testwhatAppGateway, getwhatsAppPartnerInfo } from '../services/apiServices.js';
import { MDBAlert, MDBBtn, MDBCol, MDBDatatable, MDBIcon, MDBInputGroup, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBRow, MDBTextArea, MDBSelect } from 'mdb-react-ui-kit';
import { useNavigate } from 'react-router-dom';
import {
    isEmpty,
} from "../validators/helper.js";
import PageError from './PageError.js';

import { browserName, browserVersion } from "react-device-detect";
import { useAnalytics } from '../hooks/useAnalytics';

function WhatsappGateway(props) {
    const navigate = useNavigate();
    let plansInfo = localStorage.getItem("planInfo") ? JSON.parse(localStorage.getItem("planInfo")) : null;
    const { trackButtonClick } = useAnalytics();
    const [apiError, setApiError] = useState(false);
    const [Alerttxt, setAlerttxt] = useState("");
    const [whatsappgateway, setwhatsappgateway] = useState([]);
    const [editwhatsappgateway, setEditwhatsappgateway] = useState(false);

    // Add refs to track state
    const isEditing = useRef(false);
    const isTypeChangeProgrammatic = useRef(false);

    // Partner registration state
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const [partnerData, setPartnerData] = useState(null);
    const [loadingPartner, setLoadingPartner] = useState(false);

    // Form state
    const [form1, setForm1] = useState({
        name: '',
        accesstoken: "",
        gymid: "",
        _id: "",
        apiendpoint: "",
        primary: true,
        watsapptype: 'wati' // Default to wati
    });

    console.log("form1", form1);
    const [whatsAppapiCheck, setWhatsAppapiCheck] = useState(false);
    const toggleShow2 = () => setEditwhatsappgateway(!editwhatsappgateway);

    const Setvalue = () => {
        // Don't reset if we're in edit mode
        if (isEditing.current) return;

        setForm1({
            name: "",
            accesstoken: "",
            gymid: "",
            _id: "",
            apiendpoint: "",
            primary: true,
            watsapptype: 'wati'
        });
    };

    const [addGateWay, setAddGateWay] = useState(false);
    const toggleShow4 = () => setAddGateWay(!addGateWay);
    const [error, setError] = useState({});
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const toggleShow5 = () => setDeleteConfirm(!deleteConfirm);
    const [ResetToggle, setResetToggle] = useState(false);
    const [testToken, setTestToken] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [originalData, setOriginalData] = useState([]);

    // Options for WhatsApp type dropdown
    const watsappTypeOptions = [
        { text: 'WATI', value: 'wati' },
        { text: 'Meta Cloud API', value: 'meta' }
    ];

    // Check partner registration status on mount
    useEffect(() => {
        checkRegistrationStatus();
    }, []);

    const checkRegistrationStatus = async () => {
        try {
            setLoadingPartner(true);
            const gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;

            if (!gymid) {
                return;
            }

            const partnerResponse = await getwhatsAppPartnerInfo(gymid);

            if (partnerResponse && partnerResponse !== "false") {
                const partnerinfo = await partnerResponse.json();

                if (partnerinfo?.data) {
                    // Gym has submitted registration
                    setHasSubmitted(true);
                    setPartnerData(partnerinfo.data);

                    // Format token for display (EDR****** format)
                    if (partnerinfo.data.access_token) {
                        const token = partnerinfo.data.access_token;
                        const maskedToken = token.substring(0, 3) + '*'.repeat(10) + token.substring(token.length - 3);
                        setPartnerData(prev => ({
                            ...prev,
                            masked_token: maskedToken,
                            original_token: token
                        }));
                    }
                } else {
                    // No registration found
                    setHasSubmitted(false);
                    setPartnerData(null);
                }
            } else {
                // API error or no data
                setHasSubmitted(false);
                setPartnerData(null);
            }
        } catch (error) {
            console.error("Error checking registration status:", error);
            setHasSubmitted(false);
            setPartnerData(null);
        } finally {
            setLoadingPartner(false);
        }
    };

    const handleReload = () => {
        window.location.reload();
    }
    console.log(form1);

    async function DeleteApi(e) {
        if (form1._id && form1._id !== "") {
            const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
            const gymid = userInfo.gymid || "Unknown";
            const username1 = userInfo.email || "Unknown";
            const fullName = userInfo.name || `${userInfo.fname || ""} ${userInfo.lname || ""}`.trim() || "User";
            const ip = localStorage.getItem("ipaddress");
            const browserinfo = `${browserName}-${browserVersion}.0.0`;

            await DeleteWhatsappAPI(form1._id);

            const flag = `WhatsApp Gateway deleted by ${fullName} (${form1?.name})`;
            props.onbacktoStaff(flag);
            await trackButtonClick("WhatsAppGateway", "Delete_WhatsApp_Gateway", "staff", {});
            await logEvent({
                Eventtype: "WhatsApp Gateway",
                username1,
                ip,
                flag,
                browserinfo,
                gymid
            }, gymid);

            setDeleteConfirm(false);
            Setvalue();
            setRefresh(true)
        }

        setDeleteConfirm(false);
        Setvalue();
    }

    async function AddAPIsms() {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")) || {};
        const gymid = userInfo.gymid || "Unknown";
        const username1 = userInfo.email || "User";
        const fullName = userInfo.name || `${userInfo.fname || ""} ${userInfo.lname || ""}`.trim() || "User";
        const ip = localStorage.getItem("ipaddress");
        const browserinfo = `${browserName}-${browserVersion}.0.0`;

        console.log(form1);

        // For Meta, use the token from partner data
        let accessToken = form1.accesstoken;
        if (form1.watsapptype === 'meta' && partnerData?.original_token) {
            accessToken = partnerData.original_token;
        }

        const updates = {
            name: form1.name || (form1.watsapptype === 'meta' ? 'Meta Cloud API' : form1.name),
            accesstoken: accessToken,
            gymid: gymid,
            id: form1._id ? form1._id : -1,
            apiendpoint: form1.watsapptype === 'meta' ? 'https://graph.facebook.com/v19.0' : form1.apiendpoint,
            primary: form1.primary,
            watsapptype: form1.watsapptype || 'wati'
        }
        console.log(updates);
        let errors = validateForm();

        if (errors === true) {
            // Test the gateway based on type
            const data = {
                endpoint: updates.apiendpoint,
                token: updates.accesstoken,
                watsapptype: form1.watsapptype || 'wati'
            }
            let validated = true;
            if (form1.watsapptype == 'wati') {
                const res = await testwhatAppGateway(data, gymid)

                console.log(res);
                validated = (res.status === 200) ? true : false
            }


            if (validated) {
                console.log("it is valid");
                let saverep = await CreateWhatsappAPI(updates, gymid);
                if (saverep === "false") {
                    setApiError(true)
                    return;
                }
                const recinfo = await saverep.json();
                console.log(recinfo);
                setAlerttxt("Gateway added successfully")
                const response = await getWhatsappApi(gymid);
                const smsapi = await response.json();
                setForm1({})
                console.log(smsapi);
                if (smsapi.length > 0) {
                    setwhatsappgateway(smsapi);
                }

                const action = form1._id ? "updated" : "added";
                const flag = `WhatsApp Gateway ${action} by ${fullName} (${form1.name || 'Meta Cloud API'})`;
                await trackButtonClick("WhatsAppGateway", form1._id ? "Updated_WhatsApp_Gateway" : "Create_WhatsApp_Gateway", "staff", {});
                await logEvent({ Eventtype: "WhatsApp Gateway", username1, ip, flag, browserinfo, gymid }, gymid);

                setAddGateWay(false);
                setEditwhatsappgateway(false);
                Setvalue();
            } else {
                setTestToken(true)
            }
        } else {
            setError(errors)
            console.log(errors);
        }
    }

    // Modified useEffect
    useEffect(() => {
        // Only reset form if no modals are open and we're not editing
        if (!editwhatsappgateway && !addGateWay && !isEditing.current) {
            Setvalue();
        }

        if (plansInfo != null && plansInfo.feature.whatsappintegration) {
            fetchData();
        }
    }, [refresh, editwhatsappgateway, addGateWay]);

    function updateForm1(value) {
        return setForm1((prev) => {
            return { ...prev, ...value };
        });
    }

    const handleEditClick = (row) => {
        console.log(row, 'row');
        isEditing.current = true; // Set editing flag
        setForm1(row);
        setOriginalData({ ...row }); // Store copy of original data
        toggleShow2();
    };

    async function resetTempleteHandler(e) {
        e.preventDefault();

        if (originalData) {
            setForm1({ ...originalData });
            setError({});
            // Show success message
            setResetToggle(true);
            setAlerttxt("Form reset to original values");
        } else {
            setAlerttxt("No original data found to reset");
        }
    }

    // Reset when closing modal
    const handleCloseEditModal = () => {
        isEditing.current = false; // Reset editing flag
        setForm1({});
        setOriginalData(null);
        setError({});
        toggleShow2();
    };

    async function fetchData() {
        if (localStorage.getItem("loggedUserInfo")) {
            const response = await getWhatsappApi(
                JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
            );

            if (response === "false") {
                setApiError(true)
                return;
            }

            const gateway = response && await response.json();

            console.log(gateway);
            if (gateway.length > 0) {
                // Only call Setvalue() if we're not editing
                if (!isEditing.current) {
                    Setvalue();
                }
                setwhatsappgateway(gateway);
                const filterapi = gateway.length > 0 && gateway.filter((item) => item.primary === true)
                console.log(filterapi);

                if (filterapi.length > 0) {
                    setWhatsAppapiCheck(filterapi[0].istokenexpired)
                }
            }
        }
        setRefresh(false)
    }

    // Handle WhatsApp type change - FIXED
    const handleWatsappTypeChange = (value) => {
        // Don't do anything if we're in edit mode and this is not a user-initiated change
        if (isEditing.current && !isTypeChangeProgrammatic.current) {
            return;
        }

        const selectedType = value ? value.value : 'wati';

        if (selectedType === 'meta') {
            // For Meta, set name and endpoint automatically
            updateForm1({
                watsapptype: selectedType,
                name: 'Meta Cloud API',
                apiendpoint: 'https://graph.facebook.com/v19.0'
            });
        } else {
            // For WATI, only clear if it's a new form (not editing)
            if (!isEditing.current) {
                updateForm1({
                    watsapptype: selectedType,
                    name: '',
                    apiendpoint: '',
                    accesstoken: ''
                });
            }
        }
    };

    // Handle connect button click
    const handleConnectMeta = () => {
        toggleShow4(); // Close the modal
        navigate('/whatsapp/connect');
    };

    const whatsAppapigate = whatsappgateway.filter((el) => {
        let updatedInfo = el;
        return updatedInfo;
    });

    let tmrowA = [];

    whatsAppapigate.forEach((row, index) => {
        let rarray = [];
        rarray.push(index + 1);
        rarray.push(row.name);
        rarray.push(row.watsapptype ? row.watsapptype.toUpperCase() : 'WATI'); // Show type

        // For Meta tokens, show masked version if available
        if (row.watsapptype === 'meta' && row.accesstoken) {
            const token = row.accesstoken;
            const maskedToken = token.substring(0, 3) + '*'.repeat(10) + token.substring(token.length - 3);
            rarray.push(maskedToken);
        } else {
            rarray.push(row.accesstoken ? row.accesstoken.substring(0, 15) + '...' : '');
        }

        rarray.push(row.apiendpoint);
        rarray.push(row.primary === true ? "Enable" : "Disable");

        if (props?.roleAccess?.edittemplate !== 2) {
            rarray.push(
                <div key={index}>
                    <MDBIcon icon='pen' className='me-4 fs-6 text-secondary cursor-pointer' onClick={() => handleEditClick(row)} />
                    <MDBIcon icon='trash' className='fs-6 text-secondary cursor-pointer' onClick={() => { toggleShow5(); setForm1(row); }} />
                </div>
            );
        }
        tmrowA.push(rarray);
    });

    const columns = [
        "S.no",
        "Name",
        "Type",
        "Access Token",
        "Api Endpoint",
        "Primary",
    ];

    if (props?.roleAccess?.edittemplate !== 2) {
        columns.push("Actions");
    }

    const whatsappgateway1 = {
        columns: columns,
        rows: tmrowA,
    };

    let validateForm = (e) => {
        console.log("Validating form...");
        let errors = {};

        if (form1.watsapptype === 'wati') {
            if (isEmpty(form1.name)) {
                errors.name = "Name can't be blank";
            }
            if (isEmpty(form1.accesstoken)) {
                errors.accesstoken = "Access token can't be blank";
            }
            if (isEmpty(form1.apiendpoint)) {
                errors.apiendpoint = "API Endpoint can't be blank";
            }
        }

        // For Meta, no validation needed as data comes from partner registration
        if (form1.watsapptype === 'meta') {
            if (!hasSubmitted) {
                errors.meta = "Please connect your Meta account first";
            }
        }

        setError(errors);
        if (isEmpty(errors)) {
            return true;
        } else {
            console.log("errorrrr", errors);
            return errors;
        }
    };

    return (
        <>
            {apiError ? <PageError handleReload={handleReload} /> :
                <div>
                    <div className='sms-gatewaytable'>
                        <div className='d-flex align-items-center justify-content-end mob-block mb-2'>
                            <MDBBtn className='ms-2 mob-btn' color='success' onClick={toggleShow4}>
                                <MDBIcon fas icon="plus" className='me-2' />Add
                            </MDBBtn>
                        </div>
                        <MDBDatatable
                            searchLabel="Search by WhatsApp Gateway Details"
                            fixedHeader
                            maxHeight='70vh'
                            hover
                            data={whatsappgateway1}
                            className="Transaction__table sno"
                        />
                    </div>

                    {/* Edit Modal */}
                    <MDBModal show={editwhatsappgateway} setShow={setEditwhatsappgateway} open={editwhatsappgateway} setOpen={setEditwhatsappgateway} tabIndex='-1'>
                        <MDBModalDialog centered size="lg">
                            <MDBModalContent>
                                <MDBModalHeader>
                                    <MDBModalTitle><MDBIcon fas icon="pen" className='me-2' /> Edit WhatsApp Gateway</MDBModalTitle>
                                    <MDBBtn className='btn-close' color='none' onClick={handleCloseEditModal}></MDBBtn>
                                </MDBModalHeader>
                                <MDBModalBody>
                                    <MDBRow>
                                        <MDBCol md={6}>
                                            <label>Name<span className="text-danger">*</span></label>
                                            <MDBInputGroup className='mb-3'>
                                                <input
                                                    className={form1.name === "" ? 'is-invalid form-control' : 'form-control'}
                                                    type='text'
                                                    placeholder="Enter gateway name"
                                                    value={form1.name || ''}
                                                    onChange={(e) => updateForm1({ name: e.target.value })}
                                                    disabled={form1.watsapptype === 'meta'} // Disable for Meta
                                                />
                                            </MDBInputGroup>
                                            {error.name && (
                                                <p className="text-danger small">{error.name}</p>
                                            )}
                                        </MDBCol>

                                        <MDBCol md={6}>
                                            <label>WhatsApp Type<span className="text-danger">*</span></label>
                                            <MDBSelect
                                                className='mb-3'
                                                data={watsappTypeOptions}
                                                value={form1.watsapptype || 'wati'}
                                                onChange={(e) => handleWatsappTypeChange(e)}
                                                preventFirstSelection
                                                disabled={isEditing.current} // Disable type change when editing
                                            />
                                        </MDBCol>
                                    </MDBRow>

                                    {/* Meta-specific section */}
                                    {form1.watsapptype === 'meta' && (
                                        <>
                                            {!hasSubmitted ? (
                                                <div className="text-center py-4">
                                                    <MDBIcon fab icon="facebook" size="3x" className="text-primary mb-3" />
                                                    <h5>Connect Your Meta Account</h5>
                                                    <p className="text-muted mb-4">
                                                        To use Meta Cloud API, you need to connect your Meta Business Account first.
                                                    </p>
                                                    <MDBBtn
                                                        color="primary"
                                                        size="lg"
                                                        onClick={handleConnectMeta}
                                                        className="px-5"
                                                    >
                                                        <MDBIcon fab icon="facebook" className="me-2" />
                                                        Connect Meta Account
                                                    </MDBBtn>
                                                </div>
                                            ) : (
                                                <>
                                                    <label className='mt-2'>Access Token (from partner registration)</label>
                                                    <MDBTextArea
                                                        id='textAreaExample'
                                                        rows={2}
                                                        className="form-control mb-2 bg-light"
                                                        value={partnerData?.masked_token || '******************'}
                                                        readOnly
                                                        disabled
                                                    />
                                                    <small className="text-muted d-block mb-3">
                                                        <MDBIcon fas icon="info-circle" className="me-1" />
                                                        Token is automatically populated from your Meta connection
                                                    </small>

                                                    <label className='mt-2'>API Endpoint</label>
                                                    <MDBTextArea
                                                        id='textAreaExample'
                                                        rows={2}
                                                        className="form-control mb-2 bg-light"
                                                        value="https://graph.facebook.com/v19.0"
                                                        readOnly
                                                        disabled
                                                    />
                                                    <small className="text-muted d-block mb-3">
                                                        <MDBIcon fas icon="info-circle" className="me-1" />
                                                        Endpoint is fixed for Meta Cloud API
                                                    </small>

                                                    <div className="d-flex align-items-center mt-3">
                                                        <label className="mb-0 me-3">Primary:</label>
                                                        <label className="switch">
                                                            <input
                                                                className="form-control"
                                                                type="checkbox"
                                                                disabled={form1.primary}
                                                                checked={form1.primary || false}
                                                                onChange={() => updateForm1({ primary: !form1.primary })}
                                                            />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}

                                    {/* WATI fields */}
                                    {form1.watsapptype === 'wati' && (
                                        <>
                                            <label className='mt-2'>Access Token<span className="text-danger">*</span></label>
                                            <MDBTextArea
                                                id='textAreaExample'
                                                rows={2}
                                                className={form1.accesstoken === "" ? 'is-invalid form-control mb-2' : 'form-control mb-2'}
                                                value={form1.accesstoken || ''}
                                                onChange={(e) => updateForm1({ accesstoken: e.target.value })}
                                                placeholder="Enter access token"
                                            />
                                            {error.accesstoken && (
                                                <p className="text-danger small">{error.accesstoken}</p>
                                            )}

                                            <label className='mt-2'>API Endpoint<span className="text-danger">*</span></label>
                                            <MDBTextArea
                                                id='textAreaExample'
                                                rows={2}
                                                className={form1.apiendpoint === "" ? 'is-invalid form-control mb-2' : 'form-control mb-2'}
                                                value={form1.apiendpoint || ''}
                                                onChange={(e) => updateForm1({ apiendpoint: e.target.value })}
                                                placeholder="Enter API endpoint"
                                            />
                                            {error.apiendpoint && (
                                                <p className="text-danger small">{error.apiendpoint}</p>
                                            )}

                                            <div className="d-flex align-items-center mt-3">
                                                <label className="mb-0 me-3">Primary:</label>
                                                <label className="switch">
                                                    <input
                                                        className="form-control"
                                                        type="checkbox"
                                                        disabled={form1.primary}
                                                        checked={form1.primary || false}
                                                        onChange={() => updateForm1({ primary: !form1.primary })}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </div>
                                        </>
                                    )}
                                </MDBModalBody>
                                {form1.watsapptype === 'meta' && !hasSubmitted ? (
                                    <MDBModalFooter>
                                        <MDBBtn color='secondary' onClick={() => { setForm1({}); toggleShow2(); Setvalue(); }}>
                                            Close
                                        </MDBBtn>
                                    </MDBModalFooter>
                                ) : (
                                    <MDBModalFooter className='pb-2 pe-2'>
                                        <MDBBtn color='warning' onClick={(e) => resetTempleteHandler(e)}>Reset</MDBBtn>
                                        <MDBBtn color='secondary' onClick={() => {
                                            isEditing.current = false;
                                            setForm1({});
                                            toggleShow2();
                                            Setvalue();
                                        }}>
                                            Close
                                        </MDBBtn>
                                        <MDBBtn onClick={AddAPIsms}>Save</MDBBtn>
                                    </MDBModalFooter>
                                )}
                            </MDBModalContent>
                        </MDBModalDialog>
                    </MDBModal>

                    {/* Add Modal */}
                    <MDBModal show={addGateWay} setShow={setAddGateWay} open={addGateWay} setOpen={setAddGateWay} tabIndex='-1'>
                        <MDBModalDialog centered size="lg">
                            <MDBModalContent>
                                <MDBModalHeader>
                                    <MDBModalTitle><MDBIcon fas icon="plus" className='me-2 fs-6' /> Add WhatsApp Gateway</MDBModalTitle>
                                    <MDBBtn className='btn-close' color='none' onClick={toggleShow4}></MDBBtn>
                                </MDBModalHeader>
                                <MDBModalBody>
                                    <MDBRow>
                                        <MDBCol md={6}>
                                            <label>Name<span className="text-danger">*</span></label>
                                            <MDBInputGroup className='mb-3'>
                                                <input
                                                    className={form1.name === "" ? 'is-invalid form-control' : 'form-control'}
                                                    type='text'
                                                    placeholder="Enter gateway name"
                                                    value={form1.name || ''}
                                                    onChange={(e) => updateForm1({ name: e.target.value })}
                                                    disabled={form1.watsapptype === 'meta'} // Disable for Meta
                                                />
                                            </MDBInputGroup>
                                            {error.name && (
                                                <p className="text-danger small">{error.name}</p>
                                            )}
                                        </MDBCol>

                                        <MDBCol md={6}>
                                            <label>WhatsApp Type<span className="text-danger">*</span></label>
                                            <MDBSelect
                                                className='mb-3'
                                                data={watsappTypeOptions}
                                                value={form1.watsapptype || 'wati'}
                                                onChange={(e) => handleWatsappTypeChange(e)}
                                                preventFirstSelection
                                            />
                                        </MDBCol>
                                    </MDBRow>

                                    {/* Meta-specific section */}
                                    {form1.watsapptype === 'meta' && (
                                        <>
                                            {!hasSubmitted ? (
                                                <div className="text-center py-4">
                                                    <MDBIcon fab icon="facebook" size="3x" className="text-primary mb-3" />
                                                    <h5>Connect Your Meta Account</h5>
                                                    <p className="text-muted mb-4">
                                                        To use Meta Cloud API, you need to connect your Meta Business Account first.
                                                    </p>
                                                    <MDBBtn
                                                        color="primary"
                                                        size="lg"
                                                        onClick={handleConnectMeta}
                                                        className="px-5"
                                                    >
                                                        <MDBIcon fab icon="facebook" className="me-2" />
                                                        Connect Meta Account
                                                    </MDBBtn>
                                                </div>
                                            ) : (
                                                <>
                                                    <label className='mt-2'>Access Token (from partner registration)</label>
                                                    <MDBTextArea
                                                        id='textAreaExample'
                                                        rows={2}
                                                        className="form-control mb-2 bg-light"
                                                        value={partnerData?.masked_token || 'EDR***************'}
                                                        readOnly
                                                        disabled
                                                    />
                                                    <small className="text-muted d-block mb-3">
                                                        <MDBIcon fas icon="info-circle" className="me-1" />
                                                        Token is automatically populated from your Meta connection
                                                    </small>

                                                    <label className='mt-2'>API Endpoint</label>
                                                    <MDBTextArea
                                                        id='textAreaExample'
                                                        rows={2}
                                                        className="form-control mb-2 bg-light"
                                                        value="https://graph.facebook.com/v19.0"
                                                        readOnly
                                                        disabled
                                                    />
                                                    <small className="text-muted d-block mb-3">
                                                        <MDBIcon fas icon="info-circle" className="me-1" />
                                                        Endpoint is fixed for Meta Cloud API
                                                    </small>

                                                    <div className="d-flex align-items-center mt-3">
                                                        <label className="mb-0 me-3">Primary:</label>
                                                        <label className="switch">
                                                            <input
                                                                className="form-control"
                                                                type="checkbox"
                                                                disabled={whatsAppapigate.length > 0 ? false : true}
                                                                checked={form1.primary || false}
                                                                onChange={() => updateForm1({ primary: !form1.primary })}
                                                            />
                                                            <span className="slider round"></span>
                                                        </label>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}

                                    {/* WATI fields */}
                                    {form1.watsapptype === 'wati' && (
                                        <>
                                            <label className='mt-2'>Access Token<span className="text-danger">*</span></label>
                                            <MDBTextArea
                                                id='textAreaExample'
                                                rows={2}
                                                className={form1.accesstoken === "" ? 'is-invalid form-control mb-2' : 'form-control mb-2'}
                                                value={form1.accesstoken || ''}
                                                onChange={(e) => updateForm1({ accesstoken: e.target.value })}
                                                placeholder="Enter access token"
                                            />
                                            {error.accesstoken && (
                                                <p className="text-danger small">{error.accesstoken}</p>
                                            )}

                                            <label className='mt-2'>API Endpoint<span className="text-danger">*</span></label>
                                            <MDBTextArea
                                                id='textAreaExample'
                                                rows={2}
                                                className={form1.apiendpoint === "" ? 'is-invalid form-control mb-2' : 'form-control mb-2'}
                                                value={form1.apiendpoint || ''}
                                                onChange={(e) => updateForm1({ apiendpoint: e.target.value })}
                                                placeholder="Enter API endpoint"
                                            />
                                            {error.apiendpoint && (
                                                <p className="text-danger small">{error.apiendpoint}</p>
                                            )}

                                            <div className="d-flex align-items-center mt-3">
                                                <label className="mb-0 me-3">Primary:</label>
                                                <label className="switch">
                                                    <input
                                                        className="form-control"
                                                        type="checkbox"
                                                        disabled={whatsAppapigate.length > 0 ? false : true}
                                                        checked={form1.primary || false}
                                                        onChange={() => updateForm1({ primary: !form1.primary })}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </div>
                                        </>
                                    )}
                                </MDBModalBody>
                                {form1.watsapptype === 'meta' && !hasSubmitted ? (
                                    <MDBModalFooter>
                                        <MDBBtn color='secondary' onClick={() => { toggleShow4(); Setvalue() }}>
                                            Close
                                        </MDBBtn>
                                    </MDBModalFooter>
                                ) : (
                                    <MDBModalFooter>
                                        <MDBBtn color='secondary' onClick={() => { toggleShow4(); Setvalue() }}>
                                            Close
                                        </MDBBtn>
                                        <MDBBtn onClick={AddAPIsms}>Add</MDBBtn>
                                    </MDBModalFooter>
                                )}
                            </MDBModalContent>
                        </MDBModalDialog>
                    </MDBModal>

                    {/* Delete Confirmation Modal */}
                    <MDBModal show={deleteConfirm} setShow={setDeleteConfirm} open={deleteConfirm} setOpen={setDeleteConfirm} tabIndex='-1'>
                        <MDBModalDialog size="sm" centered>
                            <MDBModalContent>
                                <MDBModalBody>
                                    <strong>
                                        Are you sure you want to delete this WhatsApp Gateway??
                                    </strong>
                                </MDBModalBody>
                                <MDBModalFooter>
                                    <MDBBtn color='secondary' onClick={() => { toggleShow5(); Setvalue() }}>
                                        Cancel
                                    </MDBBtn>
                                    <MDBBtn onClick={(e) => DeleteApi(e)}>Delete</MDBBtn>
                                </MDBModalFooter>
                            </MDBModalContent>
                        </MDBModalDialog>
                    </MDBModal>
                </div>
            }

            {/* Alerts */}
            <MDBAlert
                color="success"
                autohide
                position='top-center'
                delay={5000}
                appendToBody
                open={Alerttxt !== ""}
                onClose={() => setAlerttxt("")}
            >
                {Alerttxt}
            </MDBAlert>

            <MDBAlert
                color="danger"
                autohide
                position='top-center'
                delay={4000}
                appendToBody
                open={testToken}
                onClose={() => setTestToken(false)}
            >
                Please Enter valid Gateway
            </MDBAlert>

            <MDBAlert
                color={'warning'}
                autohide
                position='top-right'
                delay={5000}
                appendToBody
                open={whatsAppapiCheck}
                onClose={() => setWhatsAppapiCheck(false)}
            >
                Your WhatsApp access token has expired. Please update it.
            </MDBAlert>
        </>
    )
}

export default WhatsappGateway